import gql from 'nanogql';
import Config from './config';

class Authentication {

  onAuthenticationChangeListeners = [];

  constructor() {
    this.getToken();
  }

  async authenticate(username, password) {

    const query = gql`
        mutation Mutation($input:CreateIdentityTokenInput!){
            createIdentityToken(input:$input) {
                token,
                success
            }
        }
    `;

    const response = await fetch(`${Config.api.host}${Config.api.path}`, {
      method: 'POST',
      body: JSON.stringify(query({
        input: {
          username,
          password
        }
      })),
      headers: {
        'Content-Type': 'application/json'
      }
    });

    const data = (await response.json()).data.createIdentityToken;

    if (!(data && data.success)) {
      throw new Error('Failed to login');
      return this.unauthenticate();
    }

    localStorage.setItem('access_token', JSON.stringify(data.token));

    return this.authenticationChange();
  }

  isAuthenticated() {
    return !!this.getToken();
  }

  getToken() {
    const token = localStorage.getItem('access_token');
    if (!token) {
      return null;
    }
    try {
      return JSON.parse(token);
    } catch(e) {
      return null;
    }
  }

  async unauthenticate() {
    if (!this.isAuthenticated()) {
      return;
    }
    localStorage.removeItem('access_token');
    return this.authenticationChange();
  }

  async authenticationChange() {
    return this.onAuthenticationChangeListeners
      .filter((fn) => fn instanceof Function)
      .reduce((promise, fn) => promise.then(fn), Promise.resolve(null));
  }

  async onAuthenticationChange(fn) {
    if (this.onAuthenticationChangeListeners.includes(fn)) {
      return () => null;
    }
    if (!(fn instanceof Function)) {
      return () => null;
    }
    this.onAuthenticationChangeListeners.push(fn);
    return () => {
      const index = this.onAuthenticationChangeListeners.indexOf(fn);
      console.log('Removing', index);
      if (index === -1) {
        return;
      }
      this.onAuthenticationChangeListeners.splice(index, 1);
    };

  }
}

export default new Authentication();


// WEBPACK FOOTER //
// ./src/authentication.js